import React from 'react';
import Button from '@mui/material/Button';
import { Grid, Paper } from '@mui/material';
import { Form, Formik } from 'formik';
import InputForm from '../../commun/input-form';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { CommissionsFormDto } from '../../../services/dtos/commission.dto';
import '../filter-form.scss';

/**
 * Compsant qui permet de rechercher les compositions
 * @constructor
 * @param props
 */
export default function CommissionsForm(props: { handlerSearch: (e: CommissionsFormDto) => void; searching: boolean }) {
    //Initialisation des valeurs
    const iniValues: CommissionsFormDto = {
        title: '',
        date: '',
        member: '',
    };

    return (
        //Retourne la vue
        <Formik
            initialValues={iniValues}
            onReset={() => props.handlerSearch(iniValues)}
            onSubmit={props.handlerSearch}
            className="form-intervention"
        >
            {/* Formulaire */}
            <Form>
                <Paper className="filter-form" elevation={0}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} md={3.5}>
                            <InputForm id="title" name="title" label="Titre de la commission" />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <InputForm id="date" name="date" label="Date" type={'date'} />
                        </Grid>
                        <Grid item xs={12} md={2.5}>
                            <InputForm id="member" name="member" label="Membre" />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <div className="filter-form__actions">
                                <Button
                                    variant="outlined"
                                    type="reset"
                                    className="filter-form__button filter-form__button--reset"
                                    startIcon={<ClearIcon />}
                                >
                                    Annuler
                                </Button>
                                <Button
                                    data-testid={'search-interventions'}
                                    type="submit"
                                    variant="contained"
                                    className="filter-form__button"
                                    startIcon={<SearchIcon />}
                                    disabled={props.searching}
                                >
                                    {props.searching ? 'Recherche...' : 'Rechercher'}
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                </Paper>
            </Form>
        </Formik>
    );
}
